<template>
  <div class="details-modal">
    <div class="details-container">
      <div class="bg-white details-content">
        <button @click="$emit('close')" class="close-btn">X</button>
        <div class="spinner-grow" role="status" v-if="loading"></div>
        <div v-if="errorMsg" class="alert alert-danger">{{ errorMsg }}</div>

        <h3><strong>View Details</strong></h3>
        <div class="detail-row mt-4">
          <p>Account Type</p>
          <b>{{ formatText(transLimitDetails.accountType) }}</b>
        </div>
        <div class="detail-row">
          <p>Account Category</p>
          <b>{{ formatText(transLimitDetails.businessCategory || 'N/A') }}</b>
        </div>
        <div class="detail-row">
          <p>Date Created</p>
          <b>{{ formatDate(transLimitDetails.createdAt) }}</b>
        </div>
        <div class="detail-row">
          <p>Date Updated</p>
          <b>{{ formatDate(transLimitDetails.updatedAt) }}</b>
        </div>
        <div class="detail-row">
          <p>Tier Level</p>
          <b>{{ formatTier(transLimitDetails.tierLevel) }}</b>
        </div>
        <div class="detail-row">
          <p>Transfer Limit
            <span class="ti-info-alt" ref="transferTooltip" data-bs-toggle="tooltip" data-bs-placement="top"
              title="Transfer limit capped at specified amount per transaction"></span>
          </p>
          <b>{{ formatAmount(transLimitDetails.transferLimit) }}</b>
        </div>
        <div class="detail-row">
          <p>Daily Cumulative Limit
            <span class="ti-info-alt" ref="cumulativeTooltip" data-bs-toggle="tooltip" data-bs-placement="top"
              title="Daily cumulative limit capped at specified amount per day"></span>
          </p>
          <b>{{ formatAmount(transLimitDetails.dailyCumulativeLimit) }}</b>
        </div>
        <button @click="showEditForm = true" class="btn btn-primary mt-4">Edit</button>
      </div>
    </div>

    <Modal :visible="showEditForm" @close="handleCloseEditForm">
      <AddTransactionLimit :isEditMode="true" :initialData="transLimitDetails" @close="handleCloseEditForm"
       @refresh="handleRefreshAndClose" />
    </Modal>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import Modal from './Modal.vue';
import AddTransactionLimit from './AddTransactionLimit.vue';
import { Tooltip } from "bootstrap";

export default {
  components: {
    Modal,
    AddTransactionLimit
  },

  props: {
    id: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      transLimitDetails: {},
      showEditForm: false,
      loading: false,
      errorMsg: "",
    };
  },

  methods: {
    formatText(value) {
      if (!value) return 'N/A';
      return value
        .replace(/-/g, ' ')
        .replace(/\b\w/g, char => char.toUpperCase());
    },

    formatTier(tierLevel) {
      if (!tierLevel) return null;
      return tierLevel.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase()).replace(/(\w)(\w*)/, (match, first, rest) => first.toUpperCase() + rest) || '--';
    },

    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },

    formatAmount(amount) {
      return `₦${parseFloat(amount).toLocaleString("en-NG", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    },

    async fetchTransLimitDetails() {
      this.loading = true;
      try {
        const res = await axios.get(`${process.env.VUE_APP_API_URL}/get-transaction-limit/${this.id}`,
        );
        this.transLimitDetails = res.data.data;
      } catch (error) {
        this.errorMsg =
          (error.response && error.response.data && error.response.data.message) ||
          error.message;
      } finally {
        this.loading = false;
      }
    },

    handleCloseEditForm() {
    this.showEditForm = false;
  },

  handleRefreshAndClose() {
    this.showEditForm = false;
    this.$emit("refresh");
    this.$emit("close");
  },
  },

  mounted() {
    const tooltips = [
      this.$refs.transferTooltip,
      this.$refs.cumulativeTooltip,
    ];
    tooltips.forEach((tooltip) => {
      if (tooltip) new Tooltip(tooltip);
    });
  },

  watch: {
    id: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.fetchTransLimitDetails();
        }
      }
    }
  }
};
</script>

<style scoped>
.details-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 1000;
}

.details-container {
  position: relative;
  width: 500px;
  height: 100%;
  background-color: #fff;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  padding: 20px;
  overflow-y: auto;
}

.details-content {
  padding: 20px;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.detail-row {
  border-bottom: 1px solid #EBEBEB;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 0;
}

.detail-row p {
  margin-bottom: 0;
}

.detail-row b {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  width: 50%;
  text-align: right;
  font-size: 15px;
}

.btn {
  border-radius: 50px;
  height: 40px;
  background-color: #65B3C7 !important;
  border: none !important;
}

.ti-info-alt {
  font-size: 14px;
  font-weight: normal;
  color: #65B3C7;
}
</style>